module.exports = __webpack_public_path__ + "static/media/ca-logo.c5b910b9.png";